<script setup lang="ts">
import { mdiAccountCircle } from "@mdi/js";
import { PublicPage } from "@soft-db/monitoring-api-client";
import { makeColumnHelper } from "@soft-db/ui";
import AppAvatar from "../common/AppAvatar.vue";
import AppDataTable from "../common/AppDataTable.vue";

defineProps<{
	pages: PublicPage[];
}>();

const { t } = useI18n();

const { Column } = makeColumnHelper<PublicPage>();
</script>

<template>
	<AppDataTable layout="contained" :data="pages" :pagination="{ pageSize: 10, pageIndex: 0 }">
		<template #action>
			<slot name="tableAction" />
		</template>
		<template #columns>
			<Column v-slot="{ row: { original: page } }" shrink>
				<AppAvatar
					class="size-6 overflow-clip rounded-full"
					:src="page.avatarUrl || ''"
					:icon="mdiAccountCircle"
				/>
			</Column>
			<Column field="name" :header="t('common.name')" enableSorting enableGlobalFilter />
			<Column v-slot="{ row }" shrink>
				<slot name="rowAction" :page="row.original" />
			</Column>
		</template>
	</AppDataTable>
</template>
